import styled, { keyframes } from 'styled-components';
import { NavLink } from 'react-router-dom';
import { NavigationStyled } from '../Navigation';

const Menu = styled.div`
  z-index: 1;

  height: calc(100vh - 31px);
  width: 100%;
  padding: 32px;

  display: flex;
  flex-direction: column;
  align-items: center;

  background: #ffffff;
  overflow: auto;
`;

const MenuButton = styled(NavLink)`
  padding: 16px;
  border: 1px solid black;
  width: 100%;
  text-align: center;
  text-decoration: none;

  :not(:last-child) {
    margin-bottom: 32px;
  }
`;

const FilterHidden = styled.div`
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
  padding: 5px 0;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.2);
`;

const FilterBlock = styled.div`
  flex-grow: 1;
`;

const FilterFull = styled.div`
  display: flex;
  position: absolute;
  background: #fff;
  top: 89px;
  left: 0;
  width: 100%;
  height: calc(100vh - 89px);
  z-index: 2;
  flex-direction: column;
  padding: 20px 5px;
  border-top: solid 1px #a6a6a6;
  overflow: auto;
`;

const Pager = styled.div`
  display: flex;
  align-items: center;
`;

const Preloader = styled.div`
  position: absolute;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(255, 255, 255, 0.8);
  align-items: center;
  justify-content: center;
  .ms-Spinner {
    height: 100%;
  }
`;

const ListItem = styled(NavLink)`
  min-height: min-content;
  flex-shrink: 0;
  width: 100%;
  border-bottom: solid 1px #a6a6a6;
  display: flex;
  flex-direction: column;
  text-decoration: none;
  color: #000;
  &:nth-child(even) {
    background: #fefefe;
  }
`;

const ListItemIndex = styled.div`
  font-size: 10px;
  color: #a6a6a6;
  font-weight: bold;
`;

const ListItemTitle = styled.div`
  font-size: 24px;
  padding: 0 5px 5px;
`;

const ListItemAdditional = styled.div`
  font-size: 12px;
  color: #fff;
  background: #003A72;
  padding: 5px;
`;

const List = styled.div`
  display: flex;
  height: calc(100vh - 89px);
  position: relative;
  flex-direction: column;

  overflow: auto;
`;

const SigleElem = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  height: calc(100vh - 57px);
  overflow: auto;
`;

const EmptyElem = styled.div`
  position: relative;
  height: calc(100vh - 57px);
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #a6a6a6;
`;

const PropsElem = styled.div`
  display: flex;
  padding: 5px;
  label {
    color: #a6a6a6;
  }
  span {
  }
`;

const FilterFields = styled.div`
  flex-grow: 1;
`;

const FilterButtons = styled.div`
  text-align: right;
`;

export const Styled = {
  Menu,
  MenuButton,
  FilterHidden,
  Pager,
  FilterBlock,
  Preloader,
  ListItem,
  List,
  ListItemIndex,
  ListItemTitle,
  ListItemAdditional,
  SigleElem,
  EmptyElem,
  PropsElem,
  FilterFull,
  FilterFields,
  FilterButtons,
};
